import gql from 'graphql-tag';

export const getReferrerCodeByEmail = client => ({ input }) =>
  client.query({
    query: gql`
      query getReferrerCodeByEmail($input: ReferrerEmailInput!) {
        getReferrerCodeByEmail(input: $input) {
          referralCode
        }
      }
    `,
    variables: {
      input
    }
  });
export const getReferrerDetailsByCode = client => ({ input }) =>
  client.query({
    query: gql`
      query getReferrerDetailsByCode($input: ReferralCodeInput!) {
        getReferrerDetailsByCode(input: $input) {
          firstName
          lastName
        }
      }
    `,
    variables: {
      input
    }
  });
